<template>
  <WebccModal @close="closeModal">
    <div
      class="w-full md:max-w-[40rem] max-h-[80vh] rounded-lg bg-bgr overflow-y-scroll"
    >
      <!-- Header -->
      <div
        class="px-5 py-4 flex items-center justify-center md:justify-between relative"
      >
        <div
          class="ml-auto md:relative absolute right-3 md:right-0 size-8 rounded-full flex items-center justify-center cursor-pointer hover:bg-bgr-200 transition-all p-1 text-txt-weak"
          @click="closeModal"
        >
          <WebccIcon name="site/x" class="size-5" />
        </div>
      </div>
      <WebccOrDivider v-if="cmpIsReady" :with-text="false" />
      <!-- Body -->
      <div class="flex flex-col w-full p-8 relative">
        <WebccLoaderOverlay v-if="!cmpIsReady" size="sm" />
        <Signin
          v-if="authFlowType === 'signIn'"
          @is-ready="showComponent"
          @go-to="goTo"
        />
        <Signup
          v-if="authFlowType === 'signUp'"
          @is-ready="showComponent"
          @go-to="goTo"
        />
        <RegisterCodeVerification
          v-if="authFlowType === 'verification'"
          @is-ready="showComponent"
          @go-to="goTo"
        />
        <ForgotPasswordForm
          v-if="authFlowType === 'forgotPassword'"
          @is-ready="showComponent"
          @go-to="goTo"
        />
        <RecoverCodeVerification
          v-if="authFlowType === 'recoverVerification'"
          @is-ready="showComponent"
          @go-to="goTo"
        />
        <ResetPassword
          v-if="authFlowType === 'resetPassword'"
          @is-ready="showComponent"
        />
      </div>
    </div>
  </WebccModal>
</template>
<script lang="ts" setup>
const authFlow = useAuthFlow()

const authFlowType = ref<AuthFlowType>()
const cmpIsReady = ref(false)

onMounted(() => {
  authFlowType.value = authFlow.currentState.value?.flow ?? 'signIn'
})

function closeModal() {
  authFlow.toggle(false)
}

function goTo(value: AuthFlowType) {
  cmpIsReady.value = false
  authFlowType.value = value
}

function showComponent() {
  cmpIsReady.value = true
}
</script>
